import { Col, Row, Card, FormGroup, FormControl, Button } from 'react-bootstrap';
import DateTime from 'react-datetime';
import { capitalize } from 'lodash';
import BsCheckbox from '../../../../common/form/elements/bs-checkbox';

const ScansSearch = props => (
  <Card className="admin-search-filter">
    <Card.Body>
      <Row>
        <Col md={12}>
          <FormGroup>
            <FormControl
              onChange={props.onInputChange}
              placeholder="Search by id, customer number, user id, product code (ean), outer code..."
              value={props.searchValue}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={1}>
          <FormGroup>
            <BsCheckbox checked={props.valid} onClick={props.onValidChecked}>
              Valid
            </BsCheckbox>
          </FormGroup>
        </Col>
        <Col md={1}>
          <FormGroup>
            <BsCheckbox checked={props.invalid} onClick={props.onInvalidChecked}>
              Invalid
            </BsCheckbox>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <FormGroup>
            Fail reason
            <FormControl
              value={props.failReason}
              onChange={props.onFailReasonChange}
              as="select"
            >
              <option>All</option>
              {props.failReasons &&
                props.failReasons.map((failReason, index) => <option key={index} value={failReason}>{capitalize(failReason)}</option>)}
            </FormControl>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            Scan date from
            <DateTime
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              value={props.dateFromValue}
              onChange={props.onDateFromChange}
              closeOnSelect
              inputProps={{
                placeholder: 'Date from'
              }}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            Scan date to
            <DateTime
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              value={props.dateToValue}
              onChange={props.onDateToChange}
              closeOnSelect
              inputProps={{
                placeholder: 'Date to'
              }}
            />
          </FormGroup>
        </Col>
        <Col md={3} className="actions" style={{marginTop: '20px'}}>
          <Button
            className="red-ghost-btn"
            onClick={props.onSearch}
          >Search
          </Button>
          <Button
            className="red-ghost-btn"
            onClick={props.onClear}
          >Clear search
          </Button>
        </Col>
      </Row>
    </Card.Body>
  </Card>
);

export default ScansSearch;
